import React from 'react';

export const Microsoft30x30 = ({ width = 30, height = 30 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 3H14.52V14.52H3V3Z" fill="#F35325" />
    <path d="M3 15.4844H14.52V27.0044H3V15.4844Z" fill="#05A6F0" />
    <path d="M15.4805 3H27.0005V14.52H15.4805V3Z" fill="#81BC06" />
    <path
      d="M15.4805 15.4844H27.0005V27.0044H15.4805V15.4844Z"
      fill="#FFBA08"
    />
  </svg>
);
